import React, { useEffect } from 'react';

const AdvisoryBoard = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.fade-on-scroll');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="w-full">
      {/* Hero */}
      <section className="min-h-[60vh] flex items-center justify-center bg-[#F5F1ED] relative overflow-hidden">
        <div className="absolute left-20 top-1/4 w-96 h-96 border border-[#A08872]/10 rounded-full"></div>
        <div className="container mx-auto px-6 py-20 relative z-10">
          <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-4 fade-on-scroll opacity-0">ABOUT US</p>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-serif text-[#2A2A2A] mb-6 fade-on-scroll opacity-0">Advisory Board</h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 max-w-5xl">
          <div className="fade-on-scroll opacity-0">
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif text-[#2A2A2A] mb-8">
              Strategic Guidance & Expertise
            </h2>
            <p className="text-lg text-[#3D3D3D] leading-relaxed mb-12">
              UK Stage benefits from a network of experienced advisors who provide strategic guidance across real estate, finance, technology, and regulatory matters. Our advisory board brings decades of collective experience in institutional investing, development, and platform scaling.
            </p>
            
            <div className="space-y-8">
              <div className="border-l-4 border-[#8B7355] pl-8">
                <h3 className="text-2xl font-serif text-[#2A2A2A] mb-3">Real Estate & Development</h3>
                <p className="text-lg text-[#3D3D3D] leading-relaxed">
                  Seasoned professionals with track records in land acquisition, development execution, and market positioning across multiple cycles.
                </p>
              </div>
              
              <div className="border-l-4 border-[#8B7355] pl-8">
                <h3 className="text-2xl font-serif text-[#2A2A2A] mb-3">Capital Markets & Finance</h3>
                <p className="text-lg text-[#3D3D3D] leading-relaxed">
                  Experts in private equity, structured finance, and capital formation who help shape our investment frameworks and partnership structures.
                </p>
              </div>
              
              <div className="border-l-4 border-[#8B7355] pl-8">
                <h3 className="text-2xl font-serif text-[#2A2A2A] mb-3">Technology & Innovation</h3>
                <p className="text-lg text-[#3D3D3D] leading-relaxed">
                  Technologists and innovators who guide our integration of AI-driven design systems, data analytics, and digital infrastructure into real estate development.
                </p>
              </div>
              
              <div className="border-l-4 border-[#8B7355] pl-8">
                <h3 className="text-2xl font-serif text-[#2A2A2A] mb-3">Legal & Regulatory</h3>
                <p className="text-lg text-[#3D3D3D] leading-relaxed">
                  Legal experts specializing in real estate transactions, land acquisition complexities, and regulatory compliance across multiple jurisdictions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Section */}
      <section className="py-0">
        <img 
          src="https://images.unsplash.com/photo-1676718912572-b3ebcff192e3?w=1600&q=80" 
          alt="Himalayan Professional Advisory"
          className="w-full h-[220px] sm:h-[400px] md:h-[600px] object-cover fade-on-scroll opacity-0"
        />
      </section>

      {/* Closing Statement */}
      <section className="py-20 bg-[#EDE8E3]">
        <div className="container mx-auto px-6 max-w-5xl text-center">
          <p className="text-xl sm:text-2xl md:text-3xl font-serif text-[#2A2A2A] leading-relaxed fade-on-scroll opacity-0">
            This collective wisdom strengthens our execution capabilities and strategic positioning as we scale from regional platform to institutional-grade real estate enterprise.
          </p>
        </div>
      </section>
    </div>
  );
};

export default AdvisoryBoard;